import React from 'react';  
import imgURL from 'img/no_attach.png';
import { WhiteSpace } from 'antd-mobile';
 class NoImg extends React.Component{
  render(){
    return( 
      <div className="attach-img">
        <WhiteSpace/>
        <p>暂无</p>
        <img src={imgURL}/>
      </div>
      )
  }
}
export default NoImg;
 